<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4">
        <v-card class="mx-auto mb-4" height="550" outlined elevation="1" light>
          <v-container>
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  absolute
                  right
                  top
                  v-on="on"
                  v-bind="attrs"
                  class="mt-1 mr-3"
                  outlined
                  color="#1141ce"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <DisplayOptions :name="`bookmarked`" />
            </v-menu>
            <v-row>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.products.clicked") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line" />
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider />
          </v-container>
          <v-row class="scroll" dense no-gutters>
            <v-col>
              <products-carousels
                :items="infos.products_bookmarked"
                :name="`bookmarked`"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="mx-auto mb-4" height="550" outlined elevation="1" light>
          <v-container>
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  absolute
                  right
                  top
                  v-on="on"
                  v-bind="attrs"
                  class="mt-1 mr-3"
                  outlined
                  color="#1141ce"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <DisplayOptions :name="`liked`" />
            </v-menu>
            <v-row>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.products.liked") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line" />
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider />
          </v-container>
          <v-row class="scroll" dense no-gutters>
            <v-col>
              <products-carousels
                :items="infos.products_liked"
                :name="`liked`"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="mx-auto mb-4" height="550" outlined elevation="1" light>
          <v-container>
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  absolute
                  right
                  top
                  v-on="on"
                  v-bind="attrs"
                  class="mt-1 mr-3"
                  outlined
                  color="#1141ce"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <DisplayOptions :name="`disliked`" />
            </v-menu>
            <v-row>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.products.disliked") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line" />
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider />
          </v-container>
          <v-row class="scroll" dense no-gutters>
            <v-col>
              <products-carousels
                :items="infos.products_disliked_set"
                :comments="infos.products_disliked_comments"
                :name="`disliked`"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="mx-auto mb-4" height="550" outlined elevation="1" light>
          <v-container>
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  absolute
                  right
                  top
                  v-on="on"
                  v-bind="attrs"
                  class="mt-1 mr-3"
                  outlined
                  color="#1141ce"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <DisplayOptions :name="`recommended_IA`" />
            </v-menu>
            <v-row>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.products.recommended_IA") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line" />
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider />
          </v-container>
          <v-row class="scroll" dense no-gutters>
            <v-col>
              <products-carousels
                :items="infos.products_seen"
                :name="`recommended_IA`"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card class="mx-auto mb-4" height="550" outlined elevation="1" light>
          <v-container>
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  absolute
                  right
                  top
                  v-on="on"
                  v-bind="attrs"
                  class="mt-1 mr-3"
                  outlined
                  color="#1141ce"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <DisplayOptions :name="`outher`" />
            </v-menu>
            <v-row>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.products.other_prod") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line" />
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider />
          </v-container>
          <v-row class="scroll" dense no-gutters>
            <v-col>
              <products-carousels
                :items="infos.outher_prods"
                :name="`outher`"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DisplayOptions from "./DisplayOptions";
import ProductsCarousels from "./Products_carousels";

export default {
  name: "ProductsInfo",
  components: {
    ProductsCarousels,
    DisplayOptions,
  },
  data() {
    return {
      loading: false,
      isActive: false,
    };
  },
  computed: {
    infos: {
      get: function () {
        const info = this.$store.state.user.infos.user;
        return info;
      },
    },
    products: {
      get: function () {
        const prod = this.$store.state.product.products;
        return prod;
      },
    },
  },
};
</script>

<style scoped>
.scroll {
  overflow: hidden auto !important;
  scroll-behavior: smooth;
  height: 446px !important;
}
.line {
  display: block;
  position: relative;
  margin: 0 auto;
  height: 3px;
  background: rgb(0, 212, 255);
  background: linear-gradient(
    49deg,
    rgba(0, 212, 255, 1) 0%,
    rgba(2, 0, 36, 1) 0%,
    rgba(17, 65, 206, 1) 41%
  );
  width: 81%;
  left: 36%;
  top: 2px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-49%);
}

.scroll::-webkit-scrollbar {
  width: 7px;
  height: 15%; /* width of the entire scrollbar */
}
.scroll::-webkit-scrollbar-track {
  background: #80808038;
  border-radius: 20px; /* color of the tracking area */
}
.scroll::-webkit-scrollbar-thumb {
  background-color: #1a4dcd; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 1px solid grey; /* creates padding around scroll thumb */
}
</style>
